<p-dialog [(visible)]="displayProductSelectionModal" [modal]="true" [responsive]="true" [closable]="false"
    [style]="{ width: '80vw' }" class="product-selection-modal" appendTo="body">
    <ng-template pTemplate="header">
        <div class="p-d-flex w-100 p-jc-between">
            <h5 class="p-mb-0">{{ headerText }}</h5>
        </div>
    </ng-template>

    <div class="card">
        <div class="p-grid">
            <div class="p-col-12">
                <p-table #products [columns]="productCols" (onPage)="onPageChange($event)" [value]="allProducts"
                    [(selection)]="selectedProductsList" [lazy]="true" [paginator]="true" [totalRecords]="totalRecord"
                    [rows]="pageSize" [showCurrentPageReport]="true" paginatorDropdownAppendTo="body"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    [rowsPerPageOptions]="tableShowMore" dataKey="productId" selectionMode="multiple" (onRowUnselect)="onRowUnselect($event)">
                    <ng-template pTemplate="caption">
                        <div class="table-header p-px-0 p-grid" style="background-color: #ddd">
                            <div class="p-col-12 p-md-3">
                                <p-dropdown [options]="productChannels" id="productChannels"
                                    [(ngModel)]="selectedChannel" optionLabel="name" appendTo="body" [disabled]="true"></p-dropdown>
                            </div>
                            <div class="p-col-12 p-md-6">
                                <span class="p-input-icon-left" style="width: 100%">
                                    <i class="pi pi-search"></i>
                                    <input pInputText type="text" [(ngModel)]="productGlobalSearch"
                                        (ngModelChange)="changed()" placeholder="Search..." />
                                </span>
                            </div>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <ng-container *ngFor="let col of columns">
                                <th *ngIf="col.show">{{col.header}}</th>
                            </ng-container>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData let-columns="columns">
                        <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="rowIndex" [pSelectableRowDisabled]="viewOnly || fromRule">
                            <ng-container *ngFor="let col of columns">
                                <td *ngIf="col.show && col.fieldDataType == 'number'">
                                    {{ rowData[col.field] }}
                                </td>
                                <td *ngIf="col.show && col.fieldDataType == 'string'">
                                    {{ rowData[col.field] | shorten: 55}}
                                </td>
                                <td *ngIf="col.show && col.fieldDataType == 'currency'">
                                    {{ rowData[col.field] | customNumberFormat: fractionDigits | currencySymbol }}
                                </td>
                            </ng-container>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                        <tr>
                            <td colspan="12">
                                <div class="p-text-center">
                                    {{ noProductFoundOrLoadingText }}
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
    <p-footer>
        <button type="button" pButton (click)="cancelModal()" label="Cancel" class="p-button-secondary"></button>
        <button type="button" *ngIf="!(viewOnly ||(fromRule && preview))" pButton label="Add" (click)="addProduct()"
            [disabled]="!fromRule && (!selectedProductsList || selectedProductsList?.length == 0)"></button>
    </p-footer>
</p-dialog>
